import React from "react";
import "../style/footer.scss";

const Footer = () => {
  return (
    <footer className="page-footer">
      <div className="container">
        <div className="row">
          <div className="col l6 s12">
            <h5 className="white-text">Malvern & Worcester Rounders League</h5>
            <p className="grey-text text-lighten-4">
              Check out our other links to learn more and join our community!
            </p>
          </div>
          <div className="col l4 offset-l2 s12">
            <h5 className="white-text">Links</h5>
            <ul>
              <li>
                <a
                  className="grey-text text-lighten-3"
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.facebook.com/malvernandworcesterroundersleague/"
                >
                  Facebook Info Page
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className="grey-text text-lighten-3"
                  href="https://www.facebook.com/groups/4617377170/"
                >
                  Facebook Group
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className="grey-text text-lighten-3"
                  href="https://www.roundersengland.co.uk/"
                >
                  Rounders England
                </a>
              </li>
              <li>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className="grey-text text-lighten-3"
                  href="https://w.fixtureslive.com/league/6121/competitions/MWRL-Summer-2019"
                >
                  Fixtures Live
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container">
          © {new Date().getFullYear()} Malvern & Worcester Rounders League
          <span className="grey-text text-lighten-4 right my-link">
            Crafted by{" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              className="grey-text text-lighten-4"
              href="http://www.michaelballard.co.uk"
            >
              Michael Ballard
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
